export const CURRENT_CLINIC_ID_QUERY_KEY = ["current-clinic-id"] as const;
export const CURRENT_CLINIC_CUSTOMER_ID_QUERY_KEY = ["current-clinic-customer-id"] as const;
